var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 109,
    viewBox: "0 0 104 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.4713 108.816H11.4985C5.16077 108.816 0 103.656 0 97.319V16.3279C0 9.99107 5.16077 4.83105 11.4985 4.83105H92.4713C98.809 4.83105 103.97 9.99107 103.97 16.3279V97.2888C104 103.656 98.8392 108.816 92.4713 108.816ZM11.4985 11.1981C8.66164 11.1981 6.36796 13.4914 6.36796 16.3279V97.2888C6.36796 100.125 8.66164 102.419 11.4985 102.419H92.4713C95.3082 102.419 97.6019 100.125 97.6019 97.2888V16.3279C97.6019 13.4914 95.3082 11.1981 92.4713 11.1981H11.4985Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2084 22.0311C73.8503 22.0311 72.7638 20.9448 72.7638 19.5869V2.6283C72.7638 1.2704 73.8503 0.184082 75.2084 0.184082C76.5665 0.184082 77.6529 1.2704 77.6529 2.6283V19.5568C77.6529 20.9147 76.5665 22.0311 75.2084 22.0311V22.0311ZM28.52 22.0311C27.1619 22.0311 26.0754 20.9448 26.0754 19.5869V2.6283C26.0754 1.2704 27.1619 0.184082 28.52 0.184082C29.8781 0.184082 30.9646 1.2704 30.9646 2.6283V19.5568C30.9948 20.9147 29.8781 22.0311 28.52 22.0311V22.0311ZM54.9274 76.7695C44.787 76.7695 36.5479 68.5316 36.5479 58.3926C36.5479 48.2537 44.787 40.0158 54.9274 40.0158C59.5148 40.0158 63.8909 41.7056 67.271 44.7835C67.6936 45.1456 67.7237 45.8094 67.3314 46.2017C66.9692 46.6242 66.3053 46.6544 65.9129 46.2621C62.895 43.5161 59.0017 42.0073 54.9274 42.0073C45.9037 42.0073 38.5699 49.34 38.5699 58.3625C38.5699 67.3849 45.9037 74.7176 54.9274 74.7176C59.0017 74.7176 62.895 73.2088 65.9129 70.4628C66.3355 70.1007 66.9692 70.1309 67.3314 70.5232C67.6936 70.9456 67.6634 71.5793 67.271 71.9414C63.8909 75.0797 59.5148 76.7695 54.9274 76.7695V76.7695Z",
    fill: "#DAC6E1"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.93b04bd6adccc8445e69a4de8158789c.svg";
export { ForwardRef as ReactComponent };